import { render, staticRenderFns } from "./quotaMonth.vue?vue&type=template&id=4ec73098&scoped=true&"
import script from "./quotaMonth.vue?vue&type=script&lang=js&"
export * from "./quotaMonth.vue?vue&type=script&lang=js&"
import style0 from "./quotaMonth.vue?vue&type=style&index=0&id=4ec73098&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec73098",
  null
  
)

export default component.exports